import {Injectable} from '@angular/core';
import {
    EntityAction,
    EntityCollection,
    EntityCollectionReducerMethodMap,
    EntityCollectionReducerMethods,
    EntityDefinition,
    EntityDefinitionService
} from '@ngrx/data';

import {cloneDeep} from 'lodash';
import {entityMetadata} from "../../entity/entity-metadata";

@Injectable()
export class EntityCollectionPageReducerMethodsFactory {
    constructor(private entityDefinitionService: EntityDefinitionService) { }

    /** Create the  {EntityCollectionReducerMethods} for the named entity type */
    create<T>(entityName: string): EntityCollectionReducerMethodMap<T> {
        const definition = this.entityDefinitionService.getDefinition<T>(entityName);
        const methodsClass = new EntityCollectionPageReducerMethods(entityName, definition);
        return methodsClass.methods;
    }
}


export class EntityCollectionPageReducerMethods<T> extends EntityCollectionReducerMethods<T> {
    constructor(public entityName: string, public definition: EntityDefinition<T>) {
        super(entityName, definition);
    }

    protected queryManySuccess(collection: EntityCollection<T>, action: EntityAction<T[]>
    ): EntityCollection<T> {
        const ec = super.queryManySuccess(collection, action);
        // // console.logByType['queryManySuccess', collection, ec, action]);
        if ((action.payload as any).page) {


            const page = cloneDeep((action.payload as any).page);
            // page.ids = ec.ids;

            const pages = cloneDeep(((ec as any).pages));
            page.ids = action.payload.data.map(value => entityMetadata[action.payload.entityName].selectId(value));

            const tag = action.payload.tag;
            if (tag) {
                pages[tag] = page;
            }

            // (ec as any).page = (action.payload as any).page;
            (ec as any).currentPageItemIndexes = (action.payload as any).currentPageItemIndexes$;
            (ec as any).pages = pages;
        }
        return ec;
    }
}
